import { Link } from "react-router-dom";
import { BsGraphUp } from "react-icons/bs";

const BOReportButton = () => {

    return (

        <div align="center">            
            <Link to="/boreport">
                <button className="menu-btn" type="button"><BsGraphUp />&nbsp;&nbsp;BO Report</button>
            </Link>            
        </div>

    )
}

export default BOReportButton;